const urlWithLocale = ({ locale, path }: { locale: string; path: string }): string => {
  return locale?.toLowerCase() === locale ? `${locale === 'en' ? '' : `/${locale}`}${path}` : path;
};

export default urlWithLocale;
